__webpack_require__.p = "http://tool.qazando.com.br/";